export default __webpack_public_path__ + "static/media/after@3x.83875d8a.png";